var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi1828824Hover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7791 5.14369L22.8563 3.22089C22.0751 2.4385 21.0157 2 19.9104 2H3.86465C2.28231 2 1 3.28231 1 4.86465V24.1354C1 25.7177 2.28231 27 3.86465 27H23.1354C24.7177 27 26 25.7177 26 24.1354V8.08959C26 6.98428 25.5615 5.92494 24.7791 5.14369ZM5.1666 8.51035V5.90625C5.1666 5.475 5.5166 5.125 5.94785 5.125H16.8854C17.3166 5.125 17.6666 5.475 17.6666 5.90625V8.51035C17.6666 8.9416 17.3166 9.2916 16.8854 9.2916H5.94785C5.5166 9.2916 5.1666 8.9416 5.1666 8.51035ZM13.5 22.8334C10.9115 22.8334 8.8125 20.7344 8.8125 18.1459C8.8125 15.5572 10.9115 13.4584 13.5 13.4584C16.0885 13.4584 18.1875 15.5572 18.1875 18.1459C18.1875 20.7344 16.0885 22.8334 13.5 22.8334Z",
    fill: "#D42124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi1828824Hover);
export default __webpack_public_path__ + "static/media/fi_1828824hover.4c1cabe457b6f678444319040b38e391.svg";
export { ForwardRef as ReactComponent };